import React from "react";
import { Box, Button, HStack, Icon, IconButton } from "@chakra-ui/react";
import { FaRedo, FaUndo } from "react-icons/fa";
import useTranslate from "hooks/useTranslate";
import useDressingRoom from "hooks/useDressingRoom";

const TraitsControlsContainer = () => {
  const translate = useTranslate();
  const { undoSwap, redoSwap, canUndo, canRedo, resetTraits } =
    useDressingRoom();

  return (
    <HStack spacing="0">
      <IconButton
        size="sm"
        variant="link"
        py="2"
        onClick={undoSwap}
        icon={<Icon as={FaUndo} w="5" h="5" />}
        aria-label=""
        isDisabled={!canUndo}
      />
      <IconButton
        size="sm"
        variant="link"
        py="2"
        onClick={redoSwap}
        icon={<Icon as={FaRedo} w="5" h="5" />}
        aria-label=""
        isDisabled={!canRedo}
      />
      <Box>
        <Button
          ml="2"
          size="sm"
          variant="outline"
          onClick={resetTraits}
          isDisabled={!canUndo}
        >
          {translate("common:reset")}
        </Button>
      </Box>
    </HStack>
  );
};

export default TraitsControlsContainer;
